<div class="pagination mt-20">
  <div *ngIf="compact; then small; else large"></div>
</div>

<ng-template #large>
  <div class="navigator"> 
    <button (click)="navigate(limit, page - 1)" [disabled]="page == 1">{{"<"}} </button>
    <button (click)="navigate(limit, 1)" *ngIf="page > 1">1</button>
    <button *ngIf="page - 3 > 1" disabled>...</button>
    <button (click)="navigate(limit, page - 2)" *ngIf="page - 2 > 1">{{page - 2}}</button>
    <button (click)="navigate(limit, page - 1)" *ngIf="page - 1 > 1">{{page - 1}}</button>
    <button class="active" disabled>{{page}}</button>
    <button (click)="navigate(limit, page + 1)" *ngIf="page + 1 < maxPage">{{page + 1}}</button>
    <button (click)="navigate(limit, page + 2)" *ngIf="page + 2 < maxPage">{{page + 2}}</button>
    <button *ngIf="page + 3 < maxPage" disabled>...</button>
    <button (click)="navigate(limit, maxPage)" *ngIf="page < maxPage">{{maxPage}}</button>
    <button (click)="navigate(limit, page + 1)" [disabled]="!maxPage || (page == maxPage) || (count == 0)">></button>
  </div>

  <span>{{count || 0}} risultati</span>
 <br>
  <div class="limit">
    <select (change)="navigate($event.target.value, page)">
      <option *ngFor="let value of limits" [value]="value" [selected]="limit == value">{{value}}</option>
    </select>
    <span>elementi</span>
  </div>
</ng-template>

<ng-template #small>
  <div style="display: table-row;">{{count || 0}} risultati</div>

  <div class="navigator">
    <span>Pag.</span>
    <select (change)="navigate(limit, $event.target.value)">
      <option *ngFor="let value of getPagesArray()" [value]="value" [selected]="page == value">{{value}}
      </option>
    </select>
  </div>

  <div class="limit">
    <select (change)="navigate($event.target.value, page)">
      <option *ngFor="let value of limits" [value]="value" [selected]="limit == value">{{value}}</option>
    </select>
    <span>elem.</span>
  </div>
</ng-template>
